import { acceptPhoneValue } from '../../field-viewer/shared-normalizers';
export const bookingsPhoneViewer = {
    normalizeLoadedValue: acceptPhoneValue
};

//# sourceMappingURL=definition-viewer.js.map